import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThesoundsresourceComponent } from './simple-icons-thesoundsresource.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThesoundsresourceComponent ],
    exports:      [ SimpleIconsThesoundsresourceComponent ],
    bootstrap:    []
})
export class SimpleIconsThesoundsresourceModule {}
